/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

import { IState } from '../../../interfaces/account/account.interface';
import { CommonGraphqlService } from '../../../services/common.graphql.service';

@Component({
  selector: 'states',
  templateUrl: './states-select.component.html',
  styleUrls: ['./states-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return StatesSelectComponent;
      }),
      multi: true,
    },
  ],
})
export class StatesSelectComponent implements ControlValueAccessor, OnInit {
  @Input() disabled = false;
  @Input() placeholder = 'Select State';
  @Input() required = false;

  states$: Observable<IState[]>;

  value = '';

  isLoading = true;

  onChange: (value: string) => void;
  onTouched: () => void;

  //#region ControlValueAccessor

  constructor(private commonGraphqlService: CommonGraphqlService) {}

  ngOnInit() {
    this.states$ = this.commonGraphqlService.getStates().pipe(
      tap(() => {
        return (this.isLoading = false);
      }),
      retry(2),
      catchError(() => {
        return of([]);
      }),
    );
  }

  writeValue(value: any) {
    this.value = value ? value : '';
    this.onValueChanged();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  //#endregion

  onValueChanged() {
    this.onChange(this.value);
  }
}
